module.exports = __webpack_public_path__ + "static/media/caminho1.aa736cd5.JPG";